import { IBuilder, IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IInTakeSurveyQuestionChoice } from './ap_intake_survey_question_choice_builder';

export interface IInTakeSurveyQuestion {
  choices: number[];
  active_choices: number[];
  readonly id: number;
  nk: string;
  prompt: string;
  question_type: string;
  _computedNK?: string;
}
export interface IInTakeSurveyQuestionMeta extends IInTakeSurveyQuestion {
  _choices?: IInTakeSurveyQuestionChoice[];
  _question_type: string;
  _answer?: any;
}
export interface IRadioQuestionMeta extends IInTakeSurveyQuestionMeta {
  _answer: IInTakeSurveyQuestionChoice;
}

export interface ICheckboxQuestionMeta extends IInTakeSurveyQuestionMeta {
  _answer: IInTakeSurveyQuestionChoice[];
}

export class InTakeSurveyQuestion implements IInTakeSurveyQuestionMeta, IIndexable {
  choices: number[];
  active_choices: number[];
  readonly id: number;
  nk: string;
  prompt: string;
  question_type: string;
  _choices?: IInTakeSurveyQuestionChoice[];
  _question_type: string;
  _answer?: any;
  _computedNK: string;

  constructor(question: InTakeSurveyQuestion) {
    _4.merge(this, question);
  }

  static build(question: InTakeSurveyQuestion) {
    return new InTakeSurveyQuestion(question);
  }
}

export interface IInTakeSurveyPoll {
  active_questions: number[];
  readonly id: number;
  is_active: boolean;
  name: string;
  nk: string;
  questions: number[];
  show_results_page: boolean;
}

export interface IInTakeSurveyPollMeta extends IInTakeSurveyPoll {
  _questions: IInTakeSurveyQuestion[];
}

export class InTakeSurveyPoll implements IInTakeSurveyPollMeta, IIndexable {
  active_questions: number[];
  readonly id: number;
  is_active: boolean;
  name: string;
  nk: string;
  questions: number[];
  show_results_page: boolean;
  _questions: IInTakeSurveyQuestion[];

  constructor(inTakeSurveyPoll: Partial<InTakeSurveyPoll>) {
    _4.merge(this, inTakeSurveyPoll);
  }

  static build(inTakeSurveyPoll: Partial<InTakeSurveyPoll>): InTakeSurveyPoll {
    return new InTakeSurveyPoll(inTakeSurveyPoll);
  }
}

export interface IIntakeSurveyApiAnswer {
  value: string;
}

// export class InTakeSurveyAnswer {
//   readonly id: number;
//   value: string;
//   question_id: number;
//   resources: number[]; // we don't need or using this attr in poll

//   constructor(inTakeSurveyAnswer: Partial<InTakeSurveyAnswer>) {
//     _4.merge(this, inTakeSurveyAnswer);
//   }

//   static build(inTakeSurveyPoll: Partial<InTakeSurveyAnswer>): InTakeSurveyAnswer {
//     return new InTakeSurveyAnswer(inTakeSurveyPoll);
//   }
// }



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/builders/ap_intake_survey_builder.ts